var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModalClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-861 -144)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(861 144)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 23.5,
    r: 23.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 23.5,
    r: 22.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.843,3.375A19.468,19.468,0,1,0,42.311,22.843,19.465,19.465,0,0,0,22.843,3.375Zm4.932,26.516-4.932-4.932L17.91,29.891A1.5,1.5,0,1,1,15.8,27.775l4.932-4.932L15.8,17.91A1.5,1.5,0,0,1,17.91,15.8l4.932,4.932L27.775,15.8a1.5,1.5,0,0,1,2.115,2.115l-4.932,4.932,4.932,4.932a1.5,1.5,0,0,1,0,2.115A1.486,1.486,0,0,1,27.775,29.891Z",
    transform: "translate(861.657 144.657)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalClose);
export default __webpack_public_path__ + "static/media/modal-close.6f178e02d8b2de08f615f52749035483.svg";
export { ForwardRef as ReactComponent };